// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"BX-z","sponsoredTooltipWrapper":"CX-z","sponsoredTooltip":"DX-z","newCard":"EX-z"};